import { jsxs as j, Fragment as Y, jsx as l } from "react/jsx-runtime";
import { Divider as Z } from "./index.es24.js";
import { Root as g, CollapsibleContent as E } from "@radix-ui/react-collapsible";
import U from "classnames";
import { useRef as V, useState as S, useCallback as w, useEffect as _, forwardRef as M, useMemo as z } from "react";
import { SELECT_STATES as k } from "./index.es75.js";
import { selectOnlyFirstLeafItem as ee, filterItems as te, getItemPath as J, isSameItem as Q, isLeaf as B, selectSingleItem as re, toggleSelectItem as ie } from "./index.es76.js";
import d from "./index.es5568.js";
import { MockCheckbox as ae } from "./index.es5569.js";
import { mergeTooltipPropsForSmartTooltip as le } from "./index.es5534.js";
import { useTreeNode as se } from "./index.es5570.js";
import { ColorIndicator as ce } from "./index.es32.js";
import { getDisabledAria as oe } from "./index.es530.js";
import { UtilityChevronIcon as G } from "./index.es439.js";
import { BodyText as de } from "./index.es505.js";
import { Icon as ne } from "./index.es157.js";
import { SmartTooltipWrapper as pe } from "./index.es525.js";
const X = M(
  ({
    node: t,
    level: i,
    isExpanded: p,
    hasChildren: n,
    singleSelectMode: u,
    selectMode: v = "child",
    totalNodes: h,
    positionInSet: b,
    isDisabled: y,
    parentItem: x,
    onToggleExpansion: o,
    onSelect: N,
    onKeyDown: L,
    onFocusParent: A,
    renderItem: K
  }, H) => {
    const D = w(
      (e) => {
        e.stopPropagation(), e.preventDefault(), y || o(e);
      },
      [y, o]
    ), O = w(
      (e) => {
        if (e.preventDefault(), y) {
          e.stopPropagation();
          return;
        }
        const a = e.target, f = e.currentTarget.querySelector(
          "[data-expansion-indicator]"
        );
        if (f && (f === a || f.contains(a)))
          return;
        const P = u && v === "child" && n && !B(t);
        !u && n && !a.closest("[data-interactive]") || P ? (e.stopPropagation(), o(e)) : N(e);
      },
      [
        y,
        u,
        v,
        n,
        t,
        o,
        N
      ]
    ), q = w(
      (e) => {
        const { key: a } = e;
        switch (a) {
          case "Enter":
          case " ":
            e.preventDefault(), u && v === "child" && n && !B(t) ? (e.stopPropagation(), o(e)) : N(e);
            break;
          case "ArrowRight":
            e.preventDefault(), n && !p && (e.stopPropagation(), o(e));
            break;
          case "ArrowLeft":
            e.preventDefault(), n && p ? (e.stopPropagation(), o(e)) : x && A && A(x);
            break;
          default:
            L(e);
            break;
        }
      },
      [
        n,
        p,
        u,
        v,
        t,
        x,
        o,
        N,
        A,
        L
      ]
    ), R = z(() => {
      if (u)
        return t.selected === k.selected;
    }, [u, t.selected]), $ = z(() => {
      if (!u)
        switch (t.selected) {
          case k.selected:
            return !0;
          case k.indeterminate:
            return "mixed";
          default:
            return !1;
        }
    }, [u, t.selected]), T = z(() => {
      var a;
      const e = [t.label];
      return n && (e.push(p ? "expanded" : "collapsed"), e.push(`${((a = t.children) == null ? void 0 : a.length) || 0} items`)), u ? t.selected === k.selected && e.push("selected") : t.selected === k.selected ? e.push("checked") : t.selected === k.indeterminate ? e.push("partially checked") : e.push("unchecked"), t.isDisabled && e.push("disabled"), t.isLocked && e.push("locked"), e.join(", ");
    }, [t, n, p, u]), I = () => {
      if (u) return null;
      const e = t.selected === k.indeterminate, a = t.selected === k.selected;
      return /* @__PURE__ */ l("div", { "data-interactive": "true", children: /* @__PURE__ */ l(
        ae,
        {
          checked: a,
          indeterminate: e,
          disabled: t.isDisabled,
          variant: "gray",
          testId: "tree-node-checkbox"
        }
      ) });
    }, C = le({
      tooltip: t.tooltip,
      lockedTooltip: t.lockedTooltip
    }), W = typeof t.label == "string" ? t.label : String(t.label), m = oe(!!t.isDisabled, !!C, "none"), r = J(t), c = {
      ref: H,
      role: "treeitem",
      "data-node-value": t.value,
      "data-node-path": r,
      "data-expanded": n ? p : void 0,
      "aria-expanded": n ? p : void 0,
      "aria-selected": R,
      "aria-checked": $,
      "aria-level": i,
      "aria-setsize": h,
      "aria-posinset": b,
      "aria-label": T,
      "aria-details": t.isLocked ? "Tree Item in locked state" : void 0,
      onClick: O,
      onKeyDown: q,
      className: U(d.treeItem, {
        [d.selected]: t.selected === k.selected,
        [d.disabled]: t.isDisabled,
        [d.hasChildren]: n
      }),
      ...m
    }, s = K ? /* @__PURE__ */ l("div", { ...c, children: /* @__PURE__ */ j("div", { className: d.treeItemContent, style: { paddingLeft: `${i * 16}px` }, children: [
      K(t),
      n && /* @__PURE__ */ l(
        "div",
        {
          className: U(d.expansionIndicator, {
            [d.isDisabled]: t.isDisabled
          }),
          "aria-hidden": "true",
          "data-expansion-indicator": "true",
          onClick: D,
          children: /* @__PURE__ */ l(G, { direction: p ? "up" : "down" })
        }
      )
    ] }) }) : /* @__PURE__ */ l("div", { ...c, children: /* @__PURE__ */ j("div", { className: d.treeItemContent, style: { paddingLeft: `${i * 16}px` }, children: [
      I(),
      t.entity && /* @__PURE__ */ l("div", { className: d.colorIndicator, children: /* @__PURE__ */ l(ce, { entityColor: t.entity, disabled: t.isDisabled }) }),
      t.LeftComponent && /* @__PURE__ */ l("div", { className: d.leftComponent, children: t.LeftComponent }),
      /* @__PURE__ */ l("div", { className: d.label, children: /* @__PURE__ */ l(
        de,
        {
          variant: t.selected === k.selected || t.selected === k.indeterminate ? "bold" : "regular",
          element: "span",
          color: t.isDisabled ? "disabled" : "primary",
          isEllipsis: !0,
          children: t.label
        }
      ) }),
      t.RightComponent && /* @__PURE__ */ l("div", { className: d.rightComponent, children: t.RightComponent }),
      n && /* @__PURE__ */ l(
        "div",
        {
          className: U(d.expansionIndicator, {
            [d.isDisabled]: t.isDisabled
          }),
          "aria-hidden": "true",
          "data-expansion-indicator": "true",
          onClick: D,
          children: /* @__PURE__ */ l(G, { direction: p ? "up" : "down" })
        }
      ),
      t.isLocked && /* @__PURE__ */ l("div", { className: d.lockIndicator, children: /* @__PURE__ */ l(ne, { type: "Lock", size: 16 }) })
    ] }) });
    return C || t.isLocked ? /* @__PURE__ */ l(
      pe,
      {
        tooltip: C,
        isLocked: t.isLocked,
        itemLabel: W,
        isDisabled: t.isDisabled,
        isOverflowing: !1,
        testId: `tree-item-${t.value}-tooltip`,
        lockedTooltip: t.lockedTooltip,
        children: s
      }
    ) : s;
  }
);
X.displayName = "TreeItem";
const ue = ({
  items: t,
  node: i,
  level: p = 1,
  totalNodes: n,
  positionInSet: u,
  parentItem: v,
  setItems: h,
  onItemSelect: b,
  singleSelectMode: y,
  expandAllItems: x,
  selectMode: o,
  renderItem: N,
  onExpansionChange: L,
  onFocusParent: A
}) => {
  const K = V(null), H = V(null), { isExpanded: D, setIsExpanded: O, visibleChildrenCount: q } = se(i, x), R = q > 0, $ = w(() => {
    const m = !D, r = (c) => c.map((s) => Q(s, i) ? { ...s, childrenExpanded: m } : s.children ? { ...s, children: r(s.children) } : s);
    O(m), h((c) => r(c)), L == null || L(i, m);
  }, [D, i, L, O, h]), T = w(
    (m) => {
      if (i.isDisabled) return;
      let r;
      if (y) {
        if (o === "child" && !B(i)) {
          $();
          return;
        }
        re(i, h), r = k.selected;
      } else
        r = ie(i, h);
      const c = {
        ...i,
        selected: r,
        isSelected: r === k.selected,
        parents: i.parents || [],
        childrenExpanded: i.childrenExpanded,
        isHidden: i.isHidden
      };
      b == null || b(c, r);
    },
    [i, y, o, h, b, $]
  ), I = w(
    (m) => {
      $();
    },
    [$]
  ), C = w((m) => {
    var f, P;
    const { key: r } = m, c = m.target, s = c.closest('[role="tree"]'), e = Array.from((s == null ? void 0 : s.querySelectorAll('[role="treeitem"]')) || []), a = e.indexOf(c);
    switch (r) {
      case "ArrowDown":
        m.preventDefault(), a < e.length - 1 && e[a + 1].focus();
        break;
      case "ArrowUp":
        m.preventDefault(), a > 0 && e[a - 1].focus();
        break;
      case "Home":
        m.preventDefault(), (f = e[0]) == null || f.focus();
        break;
      case "End":
        m.preventDefault(), (P = e[e.length - 1]) == null || P.focus();
        break;
    }
  }, []);
  if (i.isHidden)
    return null;
  const W = U(d.item, {
    [d.disabled]: i.isDisabled
  });
  return /* @__PURE__ */ j(g, { open: D, className: d.treeRoot, children: [
    /* @__PURE__ */ j("div", { className: W, children: [
      /* @__PURE__ */ l(
        X,
        {
          ref: K,
          node: i,
          level: p,
          totalNodes: n,
          positionInSet: u,
          isDisabled: i.isDisabled,
          parentItem: v,
          isExpanded: D,
          hasChildren: R,
          singleSelectMode: !!y,
          selectMode: o,
          onToggleExpansion: I,
          onSelect: T,
          onKeyDown: C,
          onFocusParent: A,
          renderItem: N
        }
      ),
      /* @__PURE__ */ l("div", { className: d.dividerWrapper, "aria-hidden": "true", children: /* @__PURE__ */ l(Z, {}) }),
      /* @__PURE__ */ l("div", { className: d.topDividerCover })
    ] }),
    /* @__PURE__ */ l(E, { className: d.flex, ref: H, asChild: !0, children: R && D && /* @__PURE__ */ l(
      fe,
      {
        items: t,
        setItems: h,
        fromItem: i,
        parentItem: i,
        onItemSelect: b,
        singleSelectMode: y,
        selectMode: o,
        renderItem: N,
        onExpansionChange: L,
        onFocusParent: A,
        level: p
      }
    ) })
  ] });
}, fe = ({
  items: t,
  fromItem: i,
  searchTerm: p,
  expandAllItems: n,
  autoFocus: u = !1,
  selectMode: v = "child",
  singleSelectMode: h = !1,
  setItems: b,
  onItemSelect: y,
  renderItem: x,
  onExpansionChange: o,
  treeLabel: N = "Tree navigation",
  parentItem: L,
  onFocusParent: A,
  level: K = 0,
  ...H
}) => {
  const D = V(null), [O, q] = S(""), R = (i == null ? void 0 : i.children) ?? t, $ = i ? K + 1 : 1, T = w((r) => {
    q(r), setTimeout(() => q(""), 100);
  }, []);
  _(() => {
    h && ee(b, v);
  }, [h, b, v]), _(() => {
    p && (te(b, { label: p }), T(`Filtered to show items matching "${p}"`));
  }, [p, b, T]), _(() => {
    if (u && D.current) {
      const r = D.current.querySelector(
        '[role="treeitem"]'
      );
      r == null || r.focus();
    }
  }, [u]);
  const I = w((r) => {
    var f, P, F;
    const { key: c } = r, s = r.target, e = Array.from(((f = D.current) == null ? void 0 : f.querySelectorAll('[role="treeitem"]')) || []), a = e.indexOf(s);
    switch (c) {
      case "ArrowDown":
        r.preventDefault(), a < e.length - 1 && e[a + 1].focus();
        break;
      case "ArrowUp":
        r.preventDefault(), a > 0 && e[a - 1].focus();
        break;
      case "Home":
        r.preventDefault(), (P = e[0]) == null || P.focus();
        break;
      case "End":
        r.preventDefault(), (F = e[e.length - 1]) == null || F.focus();
        break;
    }
  }, []), C = w(
    (r) => {
      if (!r) return;
      const c = (a) => a.map((f) => Q(f, r) ? { ...f, childrenExpanded: !1 } : f.children ? { ...f, children: c(f.children) } : f), s = J(r), e = document.querySelector(
        `[data-node-path="${s}"]`
      );
      e ? (b((a) => c(a)), setTimeout(() => {
        e.focus();
      }, 10), o && o(r, !1)) : A && A(r);
    },
    [o, A, b]
  ), W = w(
    (r, c) => {
      let s = "";
      if (h)
        s = `${r.label} selected`;
      else
        switch (c) {
          case k.selected:
            s = `${r.label} checked`;
            break;
          case k.indeterminate:
            s = `${r.label} partially checked`;
            break;
          default:
            s = `${r.label} unchecked`;
            break;
        }
      T(s), y == null || y(r, c);
    },
    [h, T, y]
  ), m = w(
    (r, c) => {
      var a;
      const s = ((a = r.children) == null ? void 0 : a.length) || 0, e = c ? `${r.label} expanded, ${s} items available` : `${r.label} collapsed`;
      T(e), o == null || o(r, c);
    },
    [T, o]
  );
  return /* @__PURE__ */ j(Y, { children: [
    /* @__PURE__ */ l(
      "div",
      {
        "aria-live": "polite",
        "aria-atomic": "true",
        className: "sr-only",
        style: {
          position: "absolute",
          left: "-10000px",
          width: "1px",
          height: "1px",
          overflow: "hidden"
        },
        children: O
      }
    ),
    /* @__PURE__ */ l(
      "div",
      {
        role: "tree",
        ref: D,
        "aria-label": N,
        "aria-multiselectable": !h,
        onKeyDown: I,
        tabIndex: 0,
        children: R.map((r, c) => /* @__PURE__ */ l(
          ue,
          {
            items: t,
            node: r,
            level: $,
            totalNodes: R.length,
            positionInSet: c + 1,
            parentItem: i || L,
            setItems: b,
            onItemSelect: W,
            singleSelectMode: h,
            selectMode: v,
            expandAllItems: n,
            renderItem: x,
            onExpansionChange: m,
            onFocusParent: C,
            treeLabel: N,
            ...H
          },
          r.value
        ))
      }
    )
  ] });
};
export {
  fe as Tree
};
//# sourceMappingURL=index.es2468.js.map
